import {
  SYNC_MESSAGE_INTERVAL_MS,
  SYNC_PROGRESS_LIMIT,
  SYNC_SLOW_AFTER_MS,
} from './constants';

const PROGRESS_CURVE_MS = 9000;

export const readSessionFromHash = () => {
  if (typeof window === 'undefined') return '';

  const hash = window.location.hash.replace(/^#/, '');

  return new URLSearchParams(hash).get('session') || '';
};

export const getSyncProgress = (elapsedMs, messageCount) => ({
  messageIndex: Math.min(
    Math.floor(elapsedMs / SYNC_MESSAGE_INTERVAL_MS),
    Math.max(messageCount - 1, 0),
  ),
  percent: SYNC_PROGRESS_LIMIT * (1 - Math.exp(-elapsedMs / PROGRESS_CURVE_MS)),
  isSlow: elapsedMs >= SYNC_SLOW_AFTER_MS,
});

export default { readSessionFromHash, getSyncProgress };
